import { render, staticRenderFns } from "./SpecificationsModule.vue?vue&type=template&id=b9bf8082"
import script from "./SpecificationsModule.vue?vue&type=script&lang=js"
export * from "./SpecificationsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports